/**
 * PrivacyPolicyView – in-app privacy policy with design system styling.
 * Content is loaded from src/content/PRIVACY_POLICY.md (synced from docs/ for Docker builds).
 */
import ReactMarkdown from 'react-markdown'
import policyMarkdown from '../content/PRIVACY_POLICY.md?raw'
import { preparePrivacyPolicyMarkdown } from '../utils/privacyPolicyMarkdown.js'

const { lastUpdated, body } = preparePrivacyPolicyMarkdown(policyMarkdown)

const markdownLink = ({ href, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="link-cta-inline"
  >
    {children}
  </a>
)

export default function PrivacyPolicyView({ onClose }) {
  return (
    <div className="privacy-view" role="article" aria-label="Privacy Policy">
      <div className="privacy-view-inner">
        <div className="privacy-view-header">
          <button
            type="button"
            onClick={onClose}
            className="privacy-view-back button ghost"
            aria-label="Back to app"
          >
            <i className="fas fa-arrow-left" aria-hidden="true" />
            <span>Back</span>
          </button>
        </div>

        <div className="privacy-view-card card">
          <h1 className="privacy-view-title">Privacy Policy</h1>
          {lastUpdated ? (
            <p className="privacy-view-meta">
              <strong>Last Updated:</strong> {lastUpdated}
            </p>
          ) : null}

          <div className="privacy-view-markdown">
            <ReactMarkdown
              components={{
                a: markdownLink,
                hr: () => <hr className="privacy-view-divider" />,
              }}
            >
              {body}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  )
}
